import React, { useCallback, useEffect, useRef, useState } from "react";
import { CleanFiltersIcon, IconSearch, SearchAdd, SearchUser, TimesIcon } from "~misc/icons";
import useModal from "../Modal/hooks/useModal";
import Modal from "~components/Modal";
import "./styles.scss";
import useHeader from "../Header/hooks/useHeader";
import { Link } from "react-router-dom";
import { initialPath } from "~misc/paths";
import originControl from "~services/utils/originControl";
import _ from "lodash";
import { use } from "react";

const Search = ({
  onSearch,
  placeholder,
  textButton,
  hideButton,
  buttonComponent,
  clickClear,
  setLoading = (e) => console.warn("setLoading não definido"),
  initialValue,
  setClientes,
  clearButton = false,
  clearButtonPath = false,
  setButtonClear,
}) => {
  const { isModalOpen, closeModal, openModal } = useModal();
  const { path } = useHeader();

  const [isClicked, setIsClicked] = useState(false);

  const [internalValue, setInternalValue] = useState("");
  const [initialValueFirstTime, setInitialValueFirstTime] = useState(false);
  const [lastSearch, setLastSearch] = useState("");

  const { origens } = originControl();

  const search = () => {
    if (lastSearch != internalValue) {
      setLoading(true);
      onSearch(internalValue);
      setLastSearch(internalValue);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    search();
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setInternalValue(inputValue);
  };

  useEffect(() => {
    if (initialValue && !initialValueFirstTime) {
      setInternalValue(initialValue);
      setLastSearch(initialValue);
      setInitialValueFirstTime(true);
    }
  }, [initialValue]);

  const keyEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      search();
    }
  };

  const handleClearField = () => {
    const pathname = window.location.pathname;
    const key = `${pathname}-listagem`;
    localStorage.removeItem(key);
    setInternalValue("");
    onSearch("");
    setLastSearch("");
  };

  return (
    <>
      <div className="flex gap-x-4 container bg-white p-5 border-terciaria border rounded-b-lg border-t-0 flex-col md:flex-row gap-y-4 ">
        <form action="" className="grow relative flex items-center">
          <label className="absolute top-[28%] left-[10px] z-10 w-[23px] h-[23px]">
            <SearchUser />
          </label>
          <input
            className="input-search w-full py-5 px-10 rounded-lg  border border-solid border-gray-300  placeholder-primaria text-16"
            type="text"
            value={internalValue}
            placeholder={placeholder != null ? placeholder : "Buscar Cliente por Código Emissor ou Razão Social/Nome"}
            onChange={(e) => handleChange(e)}
            onKeyDown={keyEnter}
            data-test-id="input-search"
          />
          {internalValue.length > 0 && (
            <button className="absolute top-50 right-10 p-4 z-2" type="button" onClick={handleClearField}>
              <TimesIcon />
            </button>
          )}
          <button className="absolute top-50 right-0 p-4 z-2" type="button" onClick={handleSearch}>
            <IconSearch />
          </button>
        </form>
        {clearButton && clearButtonPath && (
          <>
            <div
              className="flex justify-end items-center gap-x-2  cursor-pointer bg-white  py-4 px-6"
              onClick={() => {
                setButtonClear(true);
                setInternalValue("");
                onSearch("");
                setLastSearch("");
              }}
            >
              <CleanFiltersIcon />
              <span className="desc cursor-pointer font-bold">Limpar Filtros</span>
            </div>
          </>
        )}

        {buttonComponent ??
          (!hideButton &&
            (path == `${initialPath}/carteira/prospect` ? (
              <Link
                to={`${initialPath}/carteira/prospect/novo`}
                className="grow md:grow-0 justify-center flex"
                disabled={isClicked}
              >
                <button
                  className="button-search flex py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg w-full justify-center"
                  onClick={() => {
                    openModal();
                    setIsClicked(true);
                  }}
                >
                  {textButton != null ? textButton : "Novo Cadastro "}
                  <SearchAdd />
                </button>
              </Link>
            ) : (
              <button
                className="button-search grow md:grow-0 justify-center flex py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg"
                onClick={openModal}
              >
                {textButton != null ? textButton : "Novo Cadastro "}
                <SearchAdd />
              </button>
            )))}
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Cliente já possui código emissor?"
        sub="(Já possui matriz/escritório?)"
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={`${initialPath}/carteira/busca/online`}
        linkTwo={`${initialPath}/carteira/emissor/novo?origem=${origens.listagem_carteira}`}
      />
    </>
  );
};

export default Search;
